import { __require as u } from "./index.es21.js";
var s, f;
function _() {
  if (f) return s;
  f = 1, s = i;
  function i(r) {
    this._cbs = r || {};
  }
  var o = u().EVENTS;
  return Object.keys(o).forEach(function(r) {
    if (o[r] === 0)
      r = "on" + r, i.prototype[r] = function() {
        this._cbs[r] && this._cbs[r]();
      };
    else if (o[r] === 1)
      r = "on" + r, i.prototype[r] = function(t) {
        this._cbs[r] && this._cbs[r](t);
      };
    else if (o[r] === 2)
      r = "on" + r, i.prototype[r] = function(t, c) {
        this._cbs[r] && this._cbs[r](t, c);
      };
    else
      throw Error("wrong number of arguments");
  }), s;
}
export {
  _ as __require
};
//# sourceMappingURL=index.es30.js.map
